import React from "react";
import { Modal } from "react-bootstrap";
import { MecordColors } from "Constants/Color";
import CompanyForm from "../../../Master/Company/Form/CompanyForm";
import { useDispatch } from "react-redux";
import { fetchCompanyByDropDown } from "slices/Masters/company/thunk";

interface AddCustomerModalProps {
  show: boolean;
  onHide: () => void;
  onSave?: (companyData: any) => void;
}

const AddCustomerModal: React.FC<AddCustomerModalProps> = ({
  show,
  onHide,
  onSave,
}) => {
  const dispatch = useDispatch<any>();

  const handleSuccess = async () => {
    // Refresh company dropdown
    await dispatch(fetchCompanyByDropDown());
    // Call onSave if provided
    if (onSave) {
      onSave({});
    }
    // Close modal
    onHide();
  };

  return (
    <>
      <style>
        {`
          /* Make React-Bootstrap white close button fully bright */
          .bright-white-close .btn-close {
            filter: invert(1) brightness(2);
            opacity: 1;
          }
          .bright-white-close .btn-close:hover {
            filter: invert(1) brightness(2.5);
          }
        `}
      </style>
      <Modal
        show={show}
        onHide={onHide}
        backdrop="static"
        keyboard={false}
        size="xl"
        centered
      >
        <Modal.Header
          closeButton
          closeVariant="white"
          style={{
            backgroundColor: MecordColors?.ThemeBGColor,
            paddingBottom: "20px",
          }}
          className="bright-white-close"
        >
          <Modal.Title style={{ color: "#fff" }}>Add Customer</Modal.Title>
        </Modal.Header>
      <Modal.Body
        style={{
          height: "600px",
          overflowY: "auto",
          padding: "20px",
        }}
      >
        <CompanyForm isModal={true} onSuccess={handleSuccess} />
      </Modal.Body>
      </Modal>
    </>
  );
};

export default AddCustomerModal;

